import React from 'react';
import { numberFormat } from '../../../util/araknerdlib';
import MiniStatCard from '../../Banking/MiniStatCard';

const StudentMetrics = ({billed, paid, discounted, feesBalance}) => {
    return (
        <div className="row">

              <div className="col-md-3">
                    <MiniStatCard
                        icon="fa-bookmark"
                        label="Total Bill"
                        value={numberFormat(billed)}
                        tone="primary"
                        meta=""
                        hint="Accumulated billed amount."
                        loading={false}
                    />
                </div>
 
                <div className="col-md-3">
                    <MiniStatCard
                        icon="fa-check"
                        label="Total Paid"
                        value={numberFormat(paid)} 
                        tone="success"
                        meta=""
                        hint="Accumulated paid amount."
                        loading={false}
                        />
                </div>
                <div className="col-md-3">
                    <MiniStatCard
                        icon="fa-percent"
                        label="Total Discounted"
                        value={numberFormat(discounted)} 
                        tone="warning"
                        meta=""
                        hint="Accumulated discounted amount."
                        loading={false}
                        />
                </div>

               <div className="col-md-3">
                    <MiniStatCard
                        icon="fa-balance-scale"
                        label="Fees Balance" 
                        value={numberFormat(feesBalance)} 
                        tone="danger"
                        meta=""
                        hint="Current fees balance."
                        loading={false}
                        />
                </div>

            </div>
    );
};

export default StudentMetrics;